/**
 * 账户相关 API 模块
 * 
 * 包含登录、登出、找回密码等功能
 */

import request from '../utils/request';

/**
 * 员工登录（账号密码登录）
 * @param {string} account - 账号
 * @param {string} password - 密码
 * @returns {Promise} 登录结果
 */
export function empLogin(account, password) {
    return request({
        url: '/EmpLogin',
        method: 'post',
        data: {
            account,
            password
        }
    });
}

/**
 * 员工登录（验证码登录）- 登录第二步
 * @param {string} account - 账号
 * @param {string} verificationCode - 6位数验证码
 * @returns {Promise} 登录结果
 */
export function empLoginWithCode(account, verificationCode) {
    return request({
        url: '/EmpLoginWithCode',
        method: 'post',
        data: {
            account,
            verificationCode
        }
    });
}

/**
 * 发送登录验证码（登录第一步）
 * @param {string} account - 账号（邮箱）
 * @param {string} password - 密码
 * @returns {Promise} 发送结果
 */
export function sendVerificationCode(account, password) {
    return request({
        url: '/SendVerificationCode',
        method: 'post',
        data: {
            account,
            password
        }
    });
}

/**
 * 忘记密码
 * @param {string} account - 账号
 * @returns {Promise} 处理结果
 */
export function forgotPassword(account) {
    return request({
        url: '/EmpForgotPassword',
        method: 'post',
        data: {
            account
        }
    });
}

/**
 * 重置密码
 * @param {string} account - 账号
 * @param {string} oldPassword - 验证码
 * @param {string} newPassword - 新密码
 * @returns {Promise} 重置结果
 */
export function resetPassword(account, oldPassword, newPassword) {
    return request({
        url: '/EmpResetPassword',
        method: 'post',
        data: {
            account,
            oldPassword,
            newPassword
        }
    });
}

/**
 * 更新語言設定
 * @param {string} account - 賬號
 * @param {string} languageSetting - 語言 (en-US 或 zh-TW)
 * @returns {Promise}
 */
export function updateLanguageSetting(account, languageSetting) {
    return request({
        url: '/UpdateLanguageSetting',
        method: 'post',
        data: {
            account,
            languageSetting
        }
    });
}

// 导出所有 API 函数
export default {
    empLogin,
    empLoginWithCode,
    sendVerificationCode,
    forgotPassword,
    resetPassword,
    updateLanguageSetting
};
